import { DashboardObras } from "../../models/dashboard_obras";
import { IGetDashboardObrasInformationUseCase } from "../../../presentation/useCases/read/get_dashboard_obras_information_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetDashboardObrasInformationUseCase
 */

export class GetDashboardObrasInformationUseCase implements IGetDashboardObrasInformationUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getDashboardObrasInformation(
  ): Promise<DashboardObras> {
    return await this.repository.getDashboardObrasInformation();
  }
}
